import '../document-preview-dialog.css';

import { DialogSurface } from '@kerfjs/ui/surface-scaffold';
import type { SafeHtml } from 'kerfjs';

import { documentPreview, libraryDocs } from '../../../../data/state.js';
import { demandReadOnly } from '../../../../lib/context.js';
import { isImageDocument } from '../../../../lib/entity-reference.js';
import { demandDocuments } from '../document-helpers.js';
import { GalleryAnnotations } from './components/gallery-annotations.js';
import { GalleryImageStage } from './components/gallery-image-stage.js';
import { GalleryToolbar } from './components/gallery-toolbar.js';
import { GalleryZoomFooter } from './components/gallery-zoom-footer.js';

/** Full-screen image gallery for demand documents (HS2-324319). */
export function DocumentPreviewDialog(): SafeHtml {
  const active = documentPreview.value;
  if (active === null) return <></>;
  const library = active.source === 'library';
  const images = (library ? libraryDocs.value : demandDocuments()).filter(isImageDocument);
  const index = images.findIndex((document) => document.id === active.documentId);
  const document = images[index];
  if (document === undefined) return <></>;
  const readOnly = library || demandReadOnly();
  return (
    <DialogSurface
      className="document-preview-dialog"
      label={`Image ${String(index + 1)} of ${String(images.length)}: ${document.filename}`}
      presentation="fullscreen"
      bodyInset="none"
      withoutHeader
      lightDismiss
      rootAttributes={{ 'data-auto-open-dialog': '' }}
    >
      <div class="document-preview-gallery">
        <GalleryToolbar
          active={active}
          filename={document.filename}
          documentId={document.id}
          index={index}
          count={images.length}
          readOnly={readOnly}
          library={library}
        />
        <GalleryImageStage active={active} filename={document.filename} readOnly={readOnly} />
        {active.annotating === true ? <GalleryAnnotations active={active} readOnly={readOnly} /> : null}
        <GalleryZoomFooter zoom={active.zoom ?? 1} />
      </div>
    </DialogSurface>
  );
}
